const INITIAL_STATE = {
  data: {},
  errors: {},
    
}
const cancelledAllocation = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'CANCEL_SERVICE_WEEKLY_ALLOCATION':
    return { ...INITIAL_STATE, data: action.data }
  case 'CANCEL_SERVICE_WEEKLY_ALLOCATION_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default cancelledAllocation;